// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog_blog__J1w2_","post":"blog_post__TGY3e","img":"blog_img__xa8Bt","footer":"blog_footer__FQEeQ","title":"blog_title__4nlUD","date":"blog_date__VraVz"};